import { render, staticRenderFns } from "./SecondaryDialog.vue?vue&type=template&id=c353c956&scoped=true"
import script from "./SecondaryDialog.vue?vue&type=script&lang=ts"
export * from "./SecondaryDialog.vue?vue&type=script&lang=ts"
import style0 from "./SecondaryDialog.vue?vue&type=style&index=0&id=c353c956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c353c956",
  null
  
)

export default component.exports